<template>
  <div
    style="height:130px;padding:2em;text-align:center; cursor:pointer;"
    @click="parameters()"
  >
    <img
      style="width:60px;"
      src="@/assets/img/icons/create.png"
      alt="create-icon"
    />
    <p>{{ $t("button.ajouter_reunion") }}</p>
  </div>
</template>
<script>
export default {
  methods: {
    parameters (evt) {
      this.$store.commit('CLEAR_FIELDS')
      this.$store.dispatch('popupToggle')
      this.$store.commit('ADMIN_ACTIVE_COMPONENTS', {
        cardList: false,
        parameters: true
      })
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/adminPage/components/AddMeetingButton.vue